
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.54 9.32V4.49A4.19 4.19 0 0056.35.3H41.53a4.2 4.2 0 00-4.19 4.19v.25h-15A16.48 16.48 0 005.92 21.19v20.68a16.47 16.47 0 0016.44 16.41h6.57l4.3 6 4.3-6h6.56a16.49 16.49 0 0016.42-16.45V21.15A16.28 16.28 0 0058.29 13a4.17 4.17 0 002.25-3.68zm-5.87-4.08A1.67 1.67 0 1153 6.9a1.66 1.66 0 011.67-1.66zm-5.31 0a1.67 1.67 0 11-1.67 1.66 1.66 1.66 0 011.67-1.66zm-5.31 0a1.67 1.67 0 11-1.67 1.66 1.66 1.66 0 011.67-1.66zm0 49.64h-8.3l-2.56 3.57-2.56-3.57h-8.3a13.07 13.07 0 01-13-13v-20.7a13.08 13.08 0 0113-13h15v1.14a4.2 4.2 0 004.19 4.19h13.07a13 13 0 012.51 7.64v20.69a13.07 13.07 0 01-13.01 13.04z","fill":"#d0141b"}}),_c('path',{attrs:{"d":"M44.05 8.57a1.67 1.67 0 10-1.67-1.67 1.67 1.67 0 001.67 1.67zM49.36 8.57a1.67 1.67 0 10-1.67-1.67 1.67 1.67 0 001.67 1.67zM54.67 8.57A1.67 1.67 0 1053 6.9a1.67 1.67 0 001.67 1.67z","fill":"#fff"}}),_c('path',{attrs:{"fill":"#5887da","d":"M36.2 29.65l-5.6 2.63 8.53 16.92h7.42L36.21 29.64l-.01.01z"}}),_c('path',{attrs:{"d":"M29.75 16.55H23.4v32.62h6.36V32.72a1.41 1.41 0 010-.2c-1-2.12-4.8-10-5.51-11.5a.07.07 0 010-.09.06.06 0 01.08 0A13.33 13.33 0 0027 22l2.33-.52.44-.1z","fill":"#d12223"}}),_c('path',{attrs:{"d":"M36.2 29.65l9.63-13.06h-4.3c-2 1.8-6.4 5-11.74 4.82l-.44.1L27 22c6.17 1.87 11.41-2 13.63-3.93a.07.07 0 01.1 0v.08c-2 2.69-8.37 11.57-10.19 14.07l5.6-2.63z","fill":"#8f4899"}})])
          )
        }
      }
    